import React from 'react';
import CardLogin from 'app/components/Layouts/CardLogin';
import AsanImza from 'app/components/AsanImzaComponent/AsanImza';

const ConfirmAsanImza = () => {
  return (
    <CardLogin>
      <AsanImza />
    </CardLogin>
  );
};

export default ConfirmAsanImza;
